import React from 'react'
import './profile.css'
import image1 from '../../assets/Rectangleimage2.png';
import image2 from '../../assets/Rectangleimage.png';
import person1 from '../../assets/person-1.png';
import person2 from '../../assets/person-2.png';
import icon1 from '../../assets/Vector.png';
import icon2 from '../../assets/receptionist-icon.png';
import icon3 from '../../assets/receptionist-icon.png'
import { FaArrowRight } from "react-icons/fa";

const profile = () => {
  return (
    <div className='profile-main'>
                     {/* Latest Uploaded Blogs */}
                     <div className="blogs-section">
                       <div className="blog-main">
                         <h3>Latest Uploaded Blogs</h3>
                         <button className="btn btn-outline-secondary btn-sm">View All Post</button>
                       </div>
                       <div className="row blog-card-main">
                           <div className="col-md-6 blog-card-inner">
                            <div className='blog-card'>
                             <div className="blog-image">
                               <img src={image1} alt="Blog" />
                               <span className="status-badge pending">Pending</span>
                             </div>
                             <div className="blog-content">
                               <span className="category">Income Tax</span>
                               <h5>The Impact of Technology on the Workplace: How Technology is Changing</h5>
                               <div className="blog-meta">
                                 <img src={person2} alt="Author" className="author-avatar" />
                                 <span>Jason Francisco • August 20, 2022</span>
                               </div>
                             </div>
                             </div>
                           </div>
                           <div className="col-md-6 blog-card-inner">
                            <div className='blog-card'>
                             <div className="blog-image">
                               <img src={image2} alt="Blog" />
                               <span className="status-badge approved">Approved</span>
                             </div>
                             <div className="blog-content">
                               <span className="category">Proprietary Firm</span>
                               <h5>The Impact of Technology on the Workplace: How Technology is Changing</h5>
                               <div className="blog-meta">
                                 <img src={person1} alt="Author" className="author-avatar" />
                                 <span>Tracey Wilson • August 20, 2022</span>
                               </div>
                             </div>
                             </div>
                           </div>
                       </div>
                     </div>

                     {/* Recently Viewed Services */}
                     <div className="services-section">
                       <div className=" mb-3 row services-section-inner">
                        <div className='services-title col-lg-8 col-md-8 col-sm-8 col-xs-12'>
                          <h3 className='services-text'>Recently Viewed Services</h3>
                        </div>
                        <div className='services-button col-lg-4 col-md-4 col-sm-4 col-xs-12'>
                          <button className="btn btn-outline-secondary btn-sm">View All Services</button>
                        </div>
                       </div>
                       <div className="row g-3 m-0">
                         <div className="col-md-4">
                           <div className="service-card">
                             <div className="service-icon">
                              <img src={icon1} alt="serviceIcon1"/>
                             </div>
                             <h5>LLP Registration</h5>
                             <a href="home" className="service-button">Learn More<FaArrowRight className="w-6 h-6 text-teal-500" /></a>
                           </div>
                         </div>
                         <div className="col-md-4">
                           <div className="service-card">
                             <div className="service-icon">
                               <img src={icon2} alt="serviceIcon2"  />
                               </div>
                             <h5>OPC Registration</h5>
                             <a href="home" className="service-button">Learn More  <FaArrowRight className="w-6 h-6 text-teal-500" /></a>
                           </div>
                         </div>
                         <div className="col-md-4">
                           <div className="service-card">
                             <div className="service-icon"> 
                              <img src={icon3} alt="serviceIcon3"/>
                             </div>
                             <h5>OPC Registration</h5>
                             <a href="home" className="service-button">Learn More  <FaArrowRight className="w-6 h-6 text-teal-500" /></a>
                           </div>
                         </div>
                       </div>
                     </div>
    </div>
  )
}

export default profile